// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R6fx","questions":"styles_questions__3rdd2","footer":"styles_footer__1qvKX"};